import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { ApplyStaffItem } from '../../../external/ApplyStaffApi';
import { actions } from '../../modules/Actions';

export interface ApplyStaffState {
  applyStaffList: ApplyStaffItem[];
}

export const initialStaffState: ApplyStaffState = {
  applyStaffList: []
};

export const ApplyStaffReducer = reducerWithInitialState(initialStaffState)
.case(
  actions.fetchApplyStaff, (state: ApplyStaffState, payload: ApplyStaffState) => {
    return payload;
  }
);
